import {NgModule} from '@angular/core';
import { FeaturedHomeComponent } from './featured-home.component';
import { FeaturedHomeService } from './featured-home.service';
import {CommonModule} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { SwiperModule } from '../../../node_modules/angular2-useful-swiper';
import {FeaturedHomeRoutingModule} from './featured-home-routing.module';
import { ModalModule } from 'ngx-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BreezeService } from 'app/shared/service/breeze.service';
import { EnrolToModuleService } from 'app/enrol-to-module/enrol-to-module.service';

@NgModule({
  declarations: [FeaturedHomeComponent],
  providers: [FeaturedHomeService, BreezeService, EnrolToModuleService],
  imports: [CommonModule,BrowserModule, FeaturedHomeRoutingModule,
  SwiperModule, ModalModule.forRoot(), NgxSpinnerModule],
  exports: [FeaturedHomeComponent]
})
export  class FeaturedHomeModule {
}



// WEBPACK FOOTER //
// ./src/app/featured-home/featured-home.module.ts